// extracted by mini-css-extract-plugin
export default {"premiumBanner":"index_premiumBanner_GXtWl","layout":"index_layout_WA3O7"};